'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (url) {
  var parts = url.split('/');
  var last = parts[parts.length - 1];
  var withOutId = last.replace(/^\w+?(_)/g, '');
  var clean = decodeURIComponent(withOutId);
  return clean;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/orionsoft-parts/lib/components/fields/File/cleanFileURL.js
// module id = 2582
// module chunks = 0